import { render, staticRenderFns } from "./PrestationFlight.vue?vue&type=template&id=646bdb2d&scoped=true"
import script from "./PrestationFlight.vue?vue&type=script&lang=js"
export * from "./PrestationFlight.vue?vue&type=script&lang=js"
import style0 from "./PrestationFlight.vue?vue&type=style&index=0&id=646bdb2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646bdb2d",
  null
  
)

export default component.exports